import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogContent } from "@material-ui/core";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import _ from "lodash";
import colors from "../../styles/colors";

import CustomAppService from "../../services/customapps";

const style = {
  headerText: {
    fontFamily: "Poppins-Regular",
    color: colors.primary,
    fontSize: 24,
    margin: 0,
    marginBottom: 10,
    fontWeight: 600,
  },
  text: {
    fontFamily: "Poppins-Regular",
    color: colors.primary,
    fontSize: 16,
    margin: 0,
    fontWeight: 600,
  },
  input: {
    marginBottom: 10,
    fontFamily: "Poppins-Regular",
  },
  modal: {
    borderRadius: 9,
    borderStyle: "solid 2px grey",
  },
  column: {
    display: "flex",
    flexDirection: "column",
  },
  btnRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignContent: "center",
  },
};

//props -  setIsOpen, appId, providerId,
const AddPatient = (props) => {
  const [open, setOpen] = useState(false);
  const [program, setProgram] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState("");
  const [originalStartDate, setOriginalStartDate] = useState(null);
  const [originalEndDate, setOriginalEndDate] = useState(null);

  //Open Diag when parent prop is true
  useEffect(() => {
    if (!open && props.open) {
      setProgram(props.program);
      setOpen(props.open);
      if (props.program) {
        const programStartDate = props.program.startDate;
        const programEndDate = props.program.endDate
          ? props.program.endDate
          : null;
        setStartDate(programStartDate);
        setEndDate(programEndDate);
        setOriginalStartDate(programStartDate);
        setOriginalEndDate(programEndDate);
      }
    }
  }, [props, props.open]);

  //Close Diag and Set Parent Var To Closed As Well
  const closeDiaglog = () => {
    props.close();
    setOpen(false);
  };

  const clearState = () => {
    setOpen(false);
    setProgram(null);
    setStartDate(null);
    setEndDate(null);
    setOriginalStartDate(null);
    setOriginalEndDate(null);
  };

  return (
    <Dialog open={open} onClose={() => closeDiaglog()} style={style.modal}>
      <DialogContent>
        <h3 style={style.headerText}>Edit Program Details</h3>
        <p>{props.program && props.program.programName}</p>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              label="Start Date"
              value={startDate}
              onChange={(date) => {
                setStartDate(date);
              }}
              margin="normal"
              id="date-picker-dialog"
              format="MM/dd/yyyy"
            />
          </MuiPickersUtilsProvider>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              label="End Date"
              value={endDate}
              onChange={(date) => {
                setEndDate(date);
              }}
              margin="normal"
              id="date-picker-dialog"
              format="MM/dd/yyyy"
              minDate={startDate}
              minDateMessage={"End Date must be after Start Date"}
            />
          </MuiPickersUtilsProvider>
          <div style={style.btnRow}>
            <Button
              variant="outlined"
              style={{ marginRight: 10 }}
              onClick={() => closeDiaglog()}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              style={{ backgroundColor: colors.primary, color: "white" }}
              onClick={() => {
                //Save
                CustomAppService()
                  .updateProgramForCustomApp(
                    props.appId,
                    props.customAppId,
                    program.programId,
                    originalStartDate,
                    originalEndDate,
                    startDate,
                    endDate
                  )
                  .then((response) => {
                    if (response && response.msg === "ok") {
                      setOpen(false);
                      clearState();
                      props.close();
                    } else {
                      alert(
                        (response && response.errorMessage) ||
                          "Error updating assigned program dates, please try again. If problems persist please contact AC Health Support."
                      );
                    }
                  })
                  .catch(() => {
                    alert(
                      "Error updating assigned program dates, please try again. If problems persist please contact AC Health Support."
                    );
                  });
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddPatient;



// WEBPACK FOOTER //
// ./src/components/common/CustomAppProgramEdit.js